import { Injectable } from '@angular/core';
import { SharedModule } from '../shared.module';
// import { first, map, mergeMap, takeUntil, tap, catchError } from 'rxjs/operators';
// import { Observable, Subject, of } from 'rxjs';

//SERVICES
//import { ConfigService } from '../services/config.service';

//MODELS
import { Location } from '../models/location.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const _log: boolean = false;

@Injectable({providedIn: SharedModule})
export class GoogleCloudService {

	public mapsApiLoaded: boolean = false;
	public geocoder: any;

	constructor(
		//private _configService: ConfigService
		private _httpClient: HttpClient,
	) {
		if(_log) console.log('GoogleCloudService.constructor');
	}


	public getLatLng(location: Location) {
		let addressStr: string = '';
		if(location.name) addressStr += location.name + '+';
		if(location.address.streetAddress) addressStr += location.address.streetAddress;
		if(location.address.locality) addressStr += '+' + location.address.locality;
		if(location.address.region) addressStr += ',+' + location.address.region;
		if(location.address.region) addressStr += '+' + location.address.postalCode;
		if(location.address.country) addressStr += '+' + location.address.country;

		if(_log) console.log('GoogleCloudService.getLatLng.addressStr:', addressStr);

		this.geocoder = new google.maps.Geocoder;
		
		return new Promise((resolve, reject) => {
			this.geocoder.geocode({'address': addressStr}, (results, status) => {
				if(_log) console.log('GoogleCloudService.geocoder.results:', results);
				if(_log) console.log('GoogleCloudService.geocoder.status:', status);

				if(status == google.maps.GeocoderStatus.OK) {
					const lat = results[0].geometry.location.lat(),
						lng = results[0].geometry.location.lng(),
						latLng = {lat: lat, lng: lng};
					if(_log) console.log('GoogleCloudService.geocoder.results.latLng:', latLng);
					resolve(latLng);
				} else {
					console.error('GoogleCloudService.geocoder.error:', results);
					reject({error: results, status: status});
				}
				
			})
		});
	}


	/**
	 * Lazy Load Google Maps API
	 * https://github.com/angular/components/tree/master/src/google-maps#lazy-loading-the-api
	 * 
	 * @returns 
	*/
	public loadGoogleMapsAPI() {
		if(_log) console.log('GoogleCloudService.loadGoogleMapsAPI()');
		return new Promise((resolve, reject) => {
			this._httpClient.jsonp('https://maps.googleapis.com/maps/api/js?key=' + environment.googleMapsApiKey, 'callback')
				.subscribe((data: any) => {
					if(_log) console.log('GoogleCloudService.loadGoogleMapsAPI$.data:', data);
					this.mapsApiLoaded = true;
					resolve(true);
				}, (err: any) => {
					console.error('GoogleCloudService.loadGoogleMapsAPI$.err:', err);
					reject(false);
				});
		});
	}

	public getMapsApiLoaded(){
		return this.mapsApiLoaded;
	}


}